// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__c_oph","title":"ClientInsurance_title__2LPBj","itemText":"ClientInsurance_itemText__2t7dQ"};